import format from "date-fns/format";

const fmt = (n) => Number(n || 0).toLocaleString();

const rollForwardToFuture = (date) => {
  if (!date) return null;
  const out = new Date(date);
  const now = new Date();
  while (out < now) {
    out.setMonth(out.getMonth() + 1);
  }
  return out;
};

const AITasksCard = ({ userActiveLocation, subscription, onBuyClick }) => {
  const monthlyLimit = Number(userActiveLocation?.monthly_token_limit || 0);
  const monthlyUsage = Number(userActiveLocation?.monthly_token_usage || 0);
  const monthlyRemaining = Math.max(monthlyLimit - monthlyUsage, 0);

  const bulkPurchased = Number(userActiveLocation?.bulk_tokens_purchased || 0);
  const bulkRemaining = Number(userActiveLocation?.bulk_token_balance || 0);
  const bulkUsed = Math.max(bulkPurchased - bulkRemaining, 0);
  const hasBulk = bulkPurchased > 0;

  const totalLimit = monthlyLimit + bulkPurchased;
  const totalUsed = monthlyUsage + bulkUsed;
  const totalRemaining = monthlyRemaining + bulkRemaining;
  const totalPct = totalLimit > 0 ? Math.min((totalUsed / totalLimit) * 100, 100) : 0;

  const rawResetDate = userActiveLocation?.token_reset_date
    ? new Date(userActiveLocation.token_reset_date)
    : subscription?.current_period_end
      ? new Date(subscription.current_period_end * 1000)
      : null;
  const resetDate = rollForwardToFuture(rawResetDate);

  return (
    <div className="interactive-surface rounded-xl border border-border bg-card p-5">
      <span className="text-xs uppercase tracking-wider text-muted-foreground">
        AI Tasks
      </span>

      <div className="mt-4 flex justify-between items-center gap-3">
        <span className="text-sm text-muted-foreground">
          {fmt(totalUsed)} used / {fmt(totalLimit)}
        </span>
        <span className="text-sm font-semibold text-foreground">
          {fmt(totalRemaining)} remaining
        </span>
      </div>

      <div className="ai-tasks-bar mt-2">
        <div className="ai-tasks-bar-fill" style={{ width: `${totalPct}%` }} />
      </div>

      <p className="text-xs text-muted-foreground mt-2">
        {resetDate
          ? `Monthly credits reset on ${format(resetDate, "MMMM dd, yyyy")}`
          : "Monthly reset date unavailable"}
      </p>

      {hasBulk && (
        <div className="mt-4 flex justify-between items-center">
          <span className="text-sm text-muted-foreground">
            Bulk: {fmt(bulkUsed)} / {fmt(bulkPurchased)} used
          </span>
        </div>
      )}

      <button
        type="button"
        onClick={onBuyClick}
        className="mt-4 text-sm font-semibold text-foreground underline decoration-border underline-offset-4 hover:decoration-foreground/60"
      >
        Need More AI Task?
      </button>
    </div>
  );
};

export default AITasksCard;
